export const FETCH_ATTRIBUTES_BEGIN="FETCH_ATTRIBUTES_BEGIN";
export const FETCH_ATTRIBUTES_SUCCESS="FETCH_ATTRIBUTES_SUCCESS";
export const FETCH_ATTRIBUTES_FAILURE = "FETCH_ATTRIBUTES_FAILURE";

export const FETCH_ATTRIBUTESACCOUNTS_BEGIN = "FETCH_ATTRIBUTESACCOUNTS_BEGIN";
export const FETCH_ATTRIBUTESACCOUNTS_SUCCESS = "FETCH_ATTRIBUTESACCOUNTS_SUCCESS";
export const FETCH_ATTRIBUTESACCOUNTS_FAILURE = "FETCH_ATTRIBUTESACCOUNTS_FAILURE";

export const FETCH_ATTRIBUTECURRENCYINFO_BEGIN = "FETCH_ATTRIBUTECURRENCYINFO_BEGIN";
export const FETCH_ATTRIBUTECURRENCYINFO_SUCCESS = "FETCH_ATTRIBUTECURRENCYINFO_SUCCESS";
export const FETCH_ATTRIBUTECURRENCYINFO_FAILURE = "FETCH_ATTRIBUTECURRENCYINFO_FAILURE";

export const FETCH_ATTRIBUTELEGALSTRUCTURE_BEGIN = "FETCH_ATTRIBUTELEGALSTRUCTURE_BEGIN";
export const FETCH_ATTRIBUTELEGALSTRUCTURE_SUCCESS = "FETCH_ATTRIBUTELEGALSTRUCTURE_SUCCESS";
export const FETCH_ATTRIBUTELEGALSTRUCTURE_FAILURE = "FETCH_ATTRIBUTELEGALSTRUCTURE_FAILURE";


export const FETCH_ASSETSECURITYTYPE_BEGIN="FETCH_ASSETSECURITYTYPE_BEGIN";
export const FETCH_ASSETSECURITYTYPE_SUCCESS="FETCH_ASSETSECURITYTYPE_SUCCESS";
export const FETCH_ASSETSECURITYTYPE_FAILURE="FETCH_ASSETSECURITYTYPE_FAILURE";


export const FETCH_ASSETINVESTMENTTYPE_BEGIN="FETCH_ASSETINVESTMENTTYPE_BEGIN";
export const FETCH_ASSETINVESTMENTTYPE_SUCCESS = "FETCH_ASSETINVESTMENTTYPE_SUCCESS";
export const FETCH_ASSETINVESTMENTTYPE_FAILURE = "FETCH_ASSETINVESTMENTTYPE_FAILURE";

export const FETCH_INVESTORLETTERFREQUENCY_BEGIN = "FETCH_INVESTORLETTERFREQUENCY_BEGIN";
export const FETCH_INVESTORLETTERFREQUENCY_SUCCESS="FETCH_INVESTORLETTERFREQUENCY_SUCCESS";
export const FETCH_INVESTORLETTERFREQUENCY_FAILURE="FETCH_INVESTORLETTERFREQUENCY_FAILURE";

export const FETCH_PERFORMANCEESTIMATEFREQUENCY_BEGIN = "FETCH_PERFORMANCEESTIMATEFREQUENCY_BEGIN";
export const FETCH_PERFORMANCEESTIMATEFREQUENCY_SUCCESS = "FETCH_PERFORMANCEESTIMATEFREQUENCY_SUCCESS";
export const FETCH_PERFORMANCEESTIMATEFREQUENCY_FAILURE = "FETCH_PERFORMANCEESTIMATEFREQUENCY_FAILURE";



export const FETCH_REPORTINGFREQUENCY_BEGIN="FETCH_REPORTINGFREQUENCY_BEGIN";
export const FETCH_REPORTINGFREQUENCY_SUCCESS="FETCH_REPORTINGFREQUENCY_SUCCESS";
export const FETCH_REPORTINGFREQUENCY_FAILURE="FETCH_REPORTINGFREQUENCY_FAILURE";


export const FETCH_EXPOSUREREPORTINGFREQUENCY_BEGIN="FETCH_EXPOSUREREPORTINGFREQUENCY_BEGIN";
export const FETCH_EXPOSUREREPORTINGFREQUENCY_SUCCESS = "FETCH_EXPOSUREREPORTINGFREQUENCY_SUCCESS";
export const FETCH_EXPOSUREREPORTINGFREQUENCY_FAILURE = "FETCH_EXPOSUREREPORTINGFREQUENCY_FAILURE";

export const FETCH_FILLINGSTATUS_BEGIN = "FETCH_FILLINGSTATUS_BEGIN";
export const FETCH_FILLINGSTATUS_SUCCESS="FETCH_FILLINGSTATUS_SUCCESS";
export const FETCH_FILLINGSTATUS_FAILURE="FETCH_FILLINGSTATUS_FAILURE";

export const FETCH_INVESTSINOTHERFUNDS_BEGIN = "FETCH_INVESTSINOTHERFUNDS_BEGIN";
export const FETCH_INVESTSINOTHERFUNDS_SUCCESS = "FETCH_INVESTSINOTHERFUNDS_SUCCESS";
export const FETCH_INVESTSINOTHERFUNDS_FAILURE = "FETCH_INVESTSINOTHERFUNDS_FAILURE";


export const FETCH_ASSETRATINGS_BEGIN = "FETCH_ASSETRATINGS_BEGIN";
export const FETCH_ASSETRATINGS_SUCCESS = "FETCH_ASSETRATINGS_SUCCESS";;
export const FETCH_ASSETRATINGS_FAILURE = "FETCH_ASSETRATINGS_FAILURE";

export const FETCH_ASSETODDRATINGS_BEGIN = "FETCH_ASSETODDRATINGS_BEGIN";
export const FETCH_ASSETODDRATINGS_SUCCESS = "FETCH_ASSETODDRATINGS_SUCCESS";;
export const FETCH_ASSETODDRATINGS_FAILURE = "FETCH_ASSETODDRATINGS_FAILURE";











